import { Component, input } from '@angular/core';
import {
  ColumnDef,
  createAngularTable,
  FlexRenderDirective,
  getCoreRowModel,
} from '@tanstack/angular-table';

@Component({
  selector: 'app-table',
  imports: [FlexRenderDirective],
  templateUrl: './table.html',
  styleUrl: './table.scss',
})
export class Table<T> {
  columns = input.required<ColumnDef<T>[]>();

  data = input.required<T[]>();

  table = createAngularTable(() => ({
    data: this.data(),
    columns: this.columns(),
    getCoreRowModel: getCoreRowModel(),
    debugTable: true,
  }));
}
